import React from "react";
import ActionPoint from "./ActionPoint";
import BrowserViewGlobal from "../../../Views/BrowserView";

export default function ActionPointsBrowser({ actionPoints }) {
  return (
    <>
      <BrowserViewGlobal className="view__links">
        {actionPoints.map((item, index) => {
          const key = `action-point-${item.id}`;
          return <ActionPoint key={key} tabindex={index + 1} {...item} />;
        })}
      </BrowserViewGlobal>
    </>
  );
}
